import React, { useEffect, useState } from "react";
import { getVideoGallery } from "../Service/Api";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
const VideoGallery = () => {
  const homeMenu = [
    { label: "Awards & Achievements", link: "/awardsAcheivements" },
    {
      label: "Gallery",
      link: "/Gallery",
      subMenu: [
        { label: "Photo Gallery", link: "/Gallery" },
        { label: "Video Gallery", link: "/VideoGallery" },
      ],
    },

    {
      label: "Careers",
      link: "/careers-openings",
      subMenu: [{ label: "Philosophy", link: "/philosophy" }],
    },
    { label: "School Calendar", link: "/calender" },
    {
      label: "Alumni",
      link: "",
      subMenu: [
        { label: "Admissions", link: "/admission" },
        { label: "Admissions IIT", link: "/admissionIIT" },
      ],
    },

    { label: "eMagazine", link: "/Magazine" },
    { label: "TAABIR Digital Dreams", link: "/digitaldreams" },
    {
      label: "CUET",
      link: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/CUET.pdf",
    },
  ];
  const [data, setData] = useState([]);
  const [filterData, setFilteredData] = useState([]);
  const [selectedYear, setSelectedYear] = useState("All");
  const [yearRanges, setYearRanges] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const galleryData = await getVideoGallery();

      // Sort by latest date first
      const sortedData = [...galleryData].sort(
        (a, b) => new Date(b.date) - new Date(a.date),
      );
      setData(sortedData);

      // Extract unique years from dates
      const uniqueYears = Array.from(
        new Set(
          sortedData.flatMap((item) => {
            if (item.date) {
              return [new Date(item.date).getFullYear()];
            }
            return [];
          }),
        ),
      );

      const uniqueYearRanges = uniqueYears.map((year) => `${year}`);
      uniqueYearRanges.sort((a, b) => b - a); // Descending year order
      setYearRanges(uniqueYearRanges);
    };

    fetchData();
  }, []);

  useEffect(() => {
    let filtered = data;

    if (selectedYear !== "All") {
      filtered = data.filter((item) => {
        if (item.date) {
          const year = new Date(item.date).getFullYear();
          return parseInt(selectedYear) === year;
        }
        return false;
      });
    }

    // Sort filtered data again (just in case)
    const sortedFilteredData = [...filtered].sort(
      (a, b) => new Date(b.date) - new Date(a.date),
    );
    setFilteredData(sortedFilteredData);
  }, [selectedYear, data]);

  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-gallery.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Video Gallery"
                breadEnd="Video Gallery"
                breadMid="Video Gallery"
              />
            </div>
          </div>
          <div className="row inner_cont">
            <div className="col-lg-12">
              <div className="chooseyear float-end d-block">
                <select
                  id="chooseddlYear"
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  className="yearSelection"
                >
                  <option value={"All"}>All</option>
                  {yearRanges.map((yr) => (
                    <option key={yr} value={yr}>
                      {yr}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row">
              {filterData.length > 0 &&
                filterData.map((item, index) => (
                  <div
                    className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch"
                    key={index}
                  >
                    <div className="video-gallery">
                      <Link to={item.videoUrl} target="_blank" rel="noreferrer">
                        <LazyLoad>
                          {" "}
                          <img
                            src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item?.attachments}`}
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid mx-auto d-block"
                          />
                        </LazyLoad>
                        <h6 className="text-center">{item.title}</h6>
                      </Link>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default VideoGallery;
